
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import CustomDatePicker from './CustomDatePicker';
import GuestSelector from './GuestSelector';

interface SearchFormMobileProps {
  checkIn?: Date;
  checkOut?: Date;
  guests: string;
  onCheckInChange: (date: Date | undefined) => void;
  onCheckOutChange: (date: Date | undefined) => void;
  onGuestsChange: (value: string) => void;
  onSearch: () => void;
  maxGuests?: number;
  unavailableDates?: Date[];
}

const SearchFormMobile = ({
  checkIn,
  checkOut,
  guests,
  onCheckInChange,
  onCheckOutChange,
  onGuestsChange,
  onSearch,
  maxGuests = 6,
  unavailableDates = []
}: SearchFormMobileProps) => {
  const [checkInOpen, setCheckInOpen] = useState(false);
  const [checkOutOpen, setCheckOutOpen] = useState(false);

  const handleCheckInChange = (date: Date | undefined) => {
    console.log('📅 SearchFormMobile check-in changed:', date);
    onCheckInChange(date);
    // Auto-open checkout picker after selecting check-in
    if (date) {
      setTimeout(() => setCheckOutOpen(true), 100);
    }
  };

  const handleCheckOutChange = (date: Date | undefined) => {
    console.log('📅 SearchFormMobile check-out changed:', date);
    onCheckOutChange(date);
  };

  const handleGuestsChange = (value: string) => {
    console.log('👥 SearchFormMobile guests changed:', { from: guests, to: value });
    onGuestsChange(value);
  };

  return (
    <div className="md:hidden space-y-3">
      {/* Fechas en una fila con bordes redondeados */}
      <div className="grid grid-cols-2 border border-gray-300 rounded-xl overflow-hidden">
        <div className="p-4 border-r border-gray-300">
          <div className="text-xs font-semibold text-gray-700 mb-2">LLEGADA</div>
          <CustomDatePicker 
            selected={checkIn} 
            onSelect={handleCheckInChange} 
            placeholder="Agregar fecha" 
            className="border-0 p-0 h-auto bg-transparent text-base text-gray-600" 
            title="Fecha de entrada" 
            open={checkInOpen} 
            onOpenChange={setCheckInOpen} 
            unavailableDates={unavailableDates} 
          />
        </div>
        <div className="p-4">
          <div className="text-xs font-semibold text-gray-700 mb-2">SALIDA</div>
          <CustomDatePicker 
            selected={checkOut} 
            onSelect={handleCheckOutChange} 
            placeholder="Agregar fecha" 
            className="border-0 p-0 h-auto bg-transparent text-base text-gray-600" 
            title="Fecha de salida" 
            minDate={checkIn}
            open={checkOutOpen} 
            onOpenChange={setCheckOutOpen} 
            unavailableDates={unavailableDates} 
          />
        </div>
      </div>

      {/* Huéspedes en fila separada */}
      <div className="border border-gray-300 rounded-xl p-4">
        <div className="text-xs font-semibold text-gray-700 mb-2">HUÉSPEDES</div>
        <GuestSelector 
          value={guests} 
          onChange={handleGuestsChange} 
          maxGuests={maxGuests} 
          className="border-0 p-0 h-auto bg-transparent text-base text-gray-600" 
          placeholder="1 huésped" 
        />
      </div>

      {/* Botón de búsqueda en móvil */}
      <Button 
        onClick={onSearch} 
        className="w-full h-12 text-white rounded-xl bg-blue-600 hover:bg-blue-500"
      >
        Buscar
      </Button>
    </div>
  );
};

export default SearchFormMobile;
